import {readNativeAiSceneLookup,type NativeAiSceneLookup} from '../../protocol/ai-scene-request';
import {sameAiSceneScope} from '../../protocol/ai-scene-host';
import type {NativeWorkScope} from '../../protocol/native-envelope';
type Store=Pick<Storage,'length'|'key'|'getItem'|'setItem'|'removeItem'>;
export type AiSceneReceipt={lookup:NativeAiSceneLookup;createdAt:string};
const prefix=(scope:NativeWorkScope)=>`waka-ai-scenes:v1:${scope.projectId}:${scope.workId}:${scope.surface}:`;
export function readAiSceneReceipts(store:Store,scope:NativeWorkScope){
 const rows:AiSceneReceipt[]=[];
 for(let index=0;index<store.length;index++){
  const key=store.key(index);if(!key?.startsWith(prefix(scope)))continue;
  try{const raw=JSON.parse(store.getItem(key)??'null'),lookup=readNativeAiSceneLookup(raw.lookup);
   if(!sameAiSceneScope(lookup.scope,scope)||key!==prefix(scope)+lookup.requestId||typeof raw.createdAt!=='string'||!Number.isFinite(Date.parse(raw.createdAt)))continue;
   rows.push({lookup,createdAt:raw.createdAt});
  }catch{/* Ignore malformed local receipts. */}
 }
 return rows.sort((a,b)=>b.createdAt.localeCompare(a.createdAt));
}
export function rememberAiSceneReceipt(store:Store,scope:NativeWorkScope,raw:NativeAiSceneLookup){
 const lookup=readNativeAiSceneLookup(raw);if(!sameAiSceneScope(scope,lookup.scope))throw Error('다른 작업의 요청 기록입니다.');
 const key=prefix(scope)+lookup.requestId;
 if(!store.getItem(key)){
  if(readAiSceneReceipts(store,scope).length>=50)throw Error('확인한 AI 씬 요청 기록을 먼저 지워 주세요.');
  store.setItem(key,JSON.stringify({lookup,createdAt:new Date().toISOString()}));
 }
 return readAiSceneReceipts(store,scope);
}
export function forgetAiSceneReceipt(store:Store,scope:NativeWorkScope,raw:NativeAiSceneLookup){
 const lookup=readNativeAiSceneLookup(raw);if(!sameAiSceneScope(scope,lookup.scope))throw Error('다른 작업의 요청 기록입니다.');
 store.removeItem(prefix(scope)+lookup.requestId);return readAiSceneReceipts(store,scope);
}
